var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0621 23.6665H25.1455C24.329 23.6665 23.6663 24.3292 23.6663 25.1457V42.8955C23.6663 43.712 24.329 44.3747 25.1455 44.3747H31.0621C31.8786 44.3747 32.5413 43.712 32.5413 42.8955V25.1457C32.5413 24.3292 31.8786 23.6665 31.0621 23.6665Z",
    fill: "#B82428"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2291 32.5414H13.3125C12.496 32.5414 11.8333 33.2041 11.8333 34.0206V42.8955C11.8333 43.712 12.496 44.3747 13.3125 44.3747H19.2291C20.0456 44.3747 20.7083 43.712 20.7083 42.8955V34.0206C20.7082 33.2041 20.0456 32.5414 19.2291 32.5414Z",
    fill: "#B82428"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8954 14.7916H36.9787C36.1622 14.7916 35.4995 15.4543 35.4995 16.2708V42.8955C35.4995 43.712 36.1622 44.3747 36.9787 44.3747H42.8954C43.7119 44.3747 44.3746 43.712 44.3746 42.8955V16.2708C44.3746 15.4543 43.7119 14.7916 42.8954 14.7916Z",
    fill: "#B82428"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1325 65.9497L52.4745 48.2915C56.6516 43.1914 59.1661 36.6772 59.1661 29.5832C59.1661 13.2711 45.8952 0.000219822 29.5831 0.000219822C13.271 0.000219822 0 13.2711 0 29.5832C0 45.8953 13.2709 59.1662 29.583 59.1662C36.677 59.1662 43.1912 56.6517 48.2913 52.4745L65.9495 70.1327C66.5264 70.7096 67.2836 70.9995 68.041 70.9995C68.7985 70.9995 69.5557 70.7096 70.1326 70.1327C71.2893 68.976 71.2893 67.1064 70.1325 65.9497ZM29.583 53.2497C16.534 53.2497 5.91652 42.6324 5.91652 29.5832C5.91652 16.534 16.534 5.91674 29.583 5.91674C42.632 5.91674 53.2495 16.5342 53.2495 29.5832C53.2495 42.6323 42.6322 53.2497 29.583 53.2497Z",
    fill: "#B82428"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteAudit);
export default __webpack_public_path__ + "static/media/siteAudit.4a20fcd5fa03321251e3d5a16ef46cb2.svg";
export { ForwardRef as ReactComponent };